export default "__VITE_ASSET__BY1u5SG0__"